import { $$, JNative } from "../JNative";
import { NAMESPACE } from "./_Namespace";

export class SvgHelper
{
    public static classNamespace = NAMESPACE + "SvgHelper";
    public static className = "SvgHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Global Variables

    private static idCounter = 0;
    private static _svgs: { [name: string]: JNative<HTMLElement> };

    // #endregion

    // #region Constructor

    static {
        this._svgs = {
            "empty": $$("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"></svg>"),
            "pip-background": $$("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"><circle id=\"Ellipse_6\" data-name=\"Ellipse 6\" cx=\"5\" cy=\"5\" r=\"5\"/></svg>"),
            "pip-foreground": $$("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"><circle id=\"Ellipse_5\" data-name=\"Ellipse 5\" cx=\"5\" cy=\"5\" r=\"5\"/></svg>")
        };
        $$(document).triggerHandler("SeriouslyRAD.SvgHelper:Initialized", { svgHelper: this });
    }

    // #endregion

    // #region Public Methods

    public static createSvg(key: string)
    {
        if (this._svgs && this._svgs[key])
        {
            let
                html = this._svgs[key][0].outerHTML;

            const
                matches = [...html.matchAll(/url\(#([^\)]+)/gi)];

            for (let match of matches)
                html = html.replaceAll(match[1], `svg-id-${this.idCounter++}`);

            return $$(html).addClass(key);
        }
        else
            return $$(this._svgs["empty"][0].outerHTML).addClass(key);
    }
    public static registerSvg(key: string, svg: JNative<HTMLElement>)
    {
        this._svgs[key] = svg;
    }

    // #endregion
}